import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
  faMinus
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";
import { map } from "jquery";

class F26as extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      billetes: [],
      monedas: [],
      documentos: [],
      total_efectivo: "",
      total_doc: "",
      total_otros: "",
      total_arqueado: "",
      total_fondo: "",
      diferencia: "",
      fecha_captura: "",
      usuario_id: "",
      ambito_id: "",
      monedas_importe: 0,
      billetes_importe: 0,
      observaciones: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f26as: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        `http://143.198.191.211/api/F26a/ambito/${this.props.match.params.ambito_id}?api_token=${localStorage.api_token}`,
      data: {},
    }).then((res) => {
      this.setState({ f26as: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        `http://143.198.191.211/api/Documento/${this.props.match.params.ambito_id}/26a/${id}?api_token=${localStorage.api_token}`,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      total_efectivo: 0,
      total_doc: 0,
      total_otros: 0,
      total_arqueado: 0,
      total_fondo: 0,
      diferencia: 0,
      fecha_captura: "",
      usuario_id: "",
      ambito_id: "",
      billetes: [],
      monedas: [],
      documentos: [],
      monedas_importe: 0,
      billetes_importe: 0,
      observaciones: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    let monedas = JSON.parse(row.monedas)
    let monedas_importe = 0
    let billetes = JSON.parse(row.billetes)
    let billetes_importe = 0
    monedas.forEach(element => {
      monedas_importe += element.monedas_importe
    });
    billetes.forEach(element => {
      billetes_importe += element.billetes_importe
    });
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      billetes: billetes,
      monedas: monedas,
      total_efectivo: row.total_efectivo,
      documentos: JSON.parse(row.documentos),
      total_doc: row.total_doc,
      total_otros: row.total_otros,
      total_arqueado: row.total_arqueado,
      total_fondo: row.total_fondo,
      diferencia: row.diferencia,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
      observaciones: row.observaciones,
      monedas_importe: monedas_importe,
      billetes_importe: billetes_importe,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      billetes: JSON.parse(row.billetes),
      monedas: JSON.parse(row.monedas),
      total_efectivo: row.total_efectivo,
      documentos: JSON.parse(row.documentos),
      total_doc: row.total_doc,
      total_otros: row.total_otros,
      total_arqueado: row.total_arqueado,
      total_fondo: row.total_fondo,
      diferencia: row.diferencia,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
      observaciones: row.observaciones,
      fecha_captura: row.fecha_captura,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      billetes: this.state.billetes,
      monedas: this.state.monedas,
      total_efectivo: this.state.total_efectivo,
      documentos: this.state.documentos,
      total_doc: this.state.total_doc,
      total_otros: this.state.total_otros,
      total_arqueado: this.state.total_arqueado,
      total_fondo: this.state.total_fondo,
      diferencia: this.state.diferencia,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F26a", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      billetes: this.state.billetes,
      monedas: this.state.monedas,
      total_efectivo: this.state.total_efectivo,
      documentos: this.state.documentos,
      total_doc: this.state.total_doc,
      total_otros: this.state.total_otros,
      total_arqueado: this.state.total_arqueado,
      total_fondo: this.state.total_fondo,
      diferencia: this.state.diferencia,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put(`http://143.198.191.211/api/F26a/${this.state.id}`, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        `http://143.198.191.211/api/F26a/${this.state.id}?api_token=${localStorage.api_token}`,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeBilletesCantidad = (i, e) => {
    let billetes = [...this.state.billetes]
    let billete = { ...billetes[i] }
    billete.billetes_cantidad = e.target.value
    billete.billetes_importe = parseFloat(billete.billetes_cantidad) * parseFloat(billete.billetes_denominacion.replace(",", "").replace("$", ""))
    billetes[i] = billete
    let billetes_importe = 0
    billetes.forEach(element => {
      billetes_importe += element.billetes_importe
    });
    let total_efectivo = parseFloat(this.state.monedas_importe) + billetes_importe
    let total_arqueado = parseFloat(this.state.total_doc) + total_efectivo + parseFloat(this.state.total_otros)
    let diferencia = parseFloat(this.state.total_fondo) - total_arqueado
    this.setState({ billetes: billetes, billetes_importe: billetes_importe, total_efectivo: total_efectivo, total_arqueado: total_arqueado, diferencia: diferencia })
  };

  onChangeBilletesDenominacion = (i, e) => {
    let billetes = [...this.state.billetes]
    let billete = { ...billetes[i] }
    billete.billetes_denominacion = e.target.value
    billete.billetes_importe = parseFloat(billete.billetes_cantidad) * parseFloat(billete.billetes_denominacion.replace(",", "").replace("$", ""))
    billetes[i] = billete
    let billetes_importe = 0
    billetes.forEach(element => {
      billetes_importe += element.billetes_importe
    });
    let total_efectivo = parseFloat(this.state.monedas_importe) + billetes_importe
    let total_arqueado = parseFloat(this.state.total_doc) + total_efectivo + parseFloat(this.state.total_otros)
    let diferencia = parseFloat(this.state.total_fondo) - total_arqueado
    this.setState({ billetes: billetes, billetes_importe: billetes_importe, total_efectivo: total_efectivo, total_arqueado, diferencia: diferencia, diferencia: diferencia })
  };

  onChangeBilletesImporte = e => {
    //this.setState({ billetes_importe: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeMonedasCantidad = (i, e) => {
    let monedas = [...this.state.monedas]
    let moneda = { ...monedas[i] }
    moneda.monedas_cantidad = e.target.value
    moneda.monedas_importe = parseFloat(moneda.monedas_cantidad) * parseFloat(moneda.monedas_denominacion.replace(",", "").replace("$", ""))
    monedas[i] = moneda
    let monedas_importe = 0
    monedas.forEach(element => {
      monedas_importe += element.monedas_importe
    });
    let total_efectivo = monedas_importe + parseFloat(this.state.billetes_importe)
    let total_arqueado = parseFloat(this.state.total_doc) + total_efectivo + parseFloat(this.state.total_otros)
    let diferencia = parseFloat(this.state.total_fondo) - total_arqueado
    this.setState({ monedas: monedas, monedas_importe: monedas_importe, total_efectivo: total_efectivo, total_arqueado: total_arqueado, diferencia: diferencia })
  };

  onChangeMonedasDemoninacion = (i, e) => {
    let monedas = [...this.state.monedas]
    let moneda = { ...monedas[i] }
    moneda.monedas_denominacion = e.target.value
    moneda.monedas_importe = parseFloat(moneda.monedas_cantidad) * parseFloat(moneda.monedas_denominacion.replace(",", "").replace("$", ""))
    monedas[i] = moneda
    let monedas_importe = 0
    monedas.forEach(element => {
      monedas_importe += element.monedas_importe
    });
    let total_efectivo = monedas_importe + parseFloat(this.state.billetes_importe)
    let total_arqueado = parseFloat(this.state.total_doc) + total_efectivo + parseFloat(this.state.total_otros)
    let diferencia = parseFloat(this.state.total_fondo) - total_arqueado
    this.setState({ monedas: monedas, monedas_importe: monedas_importe, total_efectivo: total_efectivo, total_arqueado: total_arqueado, diferencia: diferencia })
  };

  onChangeMonedasImporte = e => {
    //this.setState({ monedas_importe: e.target.value });
  };

  onChangeTotalEfectivo = e => {
    //this.setState({ total_efectivo: e.target.value });
  };

  onChangeFecha = (i, e) => {
    let documentos = [...this.state.documentos]
    let documento = { ...documentos[i] }
    documento.fecha = e.target.value
    documentos[i] = documento
    this.setState({ documentos: documentos })
  };

  onChangeBeneficiario = (i, e) => {
    let documentos = [...this.state.documentos]
    let documento = { ...documentos[i] }
    documento.beneficiario = e.target.value
    documentos[i] = documento
    this.setState({ documentos: documentos })
  };

  onChangeNoFolio = (i, e) => {
    let documentos = [...this.state.documentos]
    let documento = { ...documentos[i] }
    documento.no_folio = e.target.value
    documentos[i] = documento
    this.setState({ documentos: documentos })
  };

  onChangeDocImporte = (i, e) => {
    let documentos = [...this.state.documentos]
    let documento = { ...documentos[i] }
    documento.doc_importe = e.target.value
    documentos[i] = documento
    let total_doc = 0
    documentos.forEach(element => {
      total_doc += parseFloat(element.doc_importe)
    });
    let total_arqueado = parseFloat(this.state.total_efectivo) + total_doc + parseFloat(this.state.total_otros)
    let diferencia = parseFloat(this.state.total_fondo) - total_arqueado
    this.setState({ documentos: documentos, total_doc: total_doc, total_arqueado: total_arqueado, diferencia: diferencia })
  };

  onChangeTotalDocProb = e => {
    //this.setState({ total_doc: e.target.value });
  };

  onChangeTotalOtros = e => {
    let total_arqueado = parseFloat(this.state.total_efectivo) + parseFloat(this.state.total_doc) + parseFloat(e.target.value)
    let diferencia = parseFloat(this.state.total_fondo) - total_arqueado
    this.setState({ total_otros: e.target.value, total_arqueado: total_arqueado, diferencia: diferencia });
  };

  onChangeTotalArqueado = e => {
    //this.setState({ total_arqueado: e.target.value });
  };

  onChangeTotalFondo = e => {
    let total_arqueado = parseFloat(this.state.total_efectivo) + parseFloat(this.state.total_doc) + parseFloat(this.state.total_otros)
    let diferencia = parseFloat(e.target.value) - total_arqueado
    this.setState({ total_fondo: e.target.value, total_arqueado: total_arqueado, diferencia: diferencia });
  };

  onChangeDiferencia = e => {
    this.setState({ diferencia: e.target.value });
  };

  onChangeFechaCaptura = e => {
    this.setState({ fecha_captura: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };

  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"26a"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  addBillete = (e) => {
    let billete = { billetes_cantidad: "0", billetes_denominacion: "$20", billetes_importe: "" }
    let billetes = [...this.state.billetes, billete]
    this.setState({ billetes: billetes })
  };

  dellBillete = (i) => {
    let billetes = this.state.billetes
    billetes.splice(i, 1)
    let billetes_importe = 0
    billetes.forEach(element => {
      billetes_importe += element.billetes_importe
    });
    let total_efectivo = billetes_importe + parseFloat(this.state.monedas_importe)
    this.setState({ billetes: billetes, billetes_importe: billetes_importe, total_efectivo: total_efectivo })
  };

  addMoneda = (e) => {
    let moneda = { monedas_cantidad: "0", monedas_denominacion: "$0.05", monedas_importe: "" }
    let monedas = [...this.state.monedas, moneda]
    this.setState({ monedas: monedas })
  };

  dellMoneda = (i) => {
    let monedas = this.state.monedas
    monedas.splice(i, 1)
    let monedas_importe = 0
    monedas.forEach(element => {
      monedas_importe += element.monedas_importe
    });
    let total_efectivo = monedas_importe + parseFloat(this.state.billetes_importe)
    this.setState({ monedas: monedas, monedas_importe: monedas_importe, total_efectivo: total_efectivo })
  };

  addDocumento = (e) => {
    let documento = { fecha: "", beneficiario: "", no_folio: "", doc_importe: "0" }
    let documentos = [...this.state.documentos, documento]
    this.setState({ documentos: documentos })
  };

  dellDocumento = (i) => {
    let documentos = this.state.documentos
    documentos.splice(i, 1)
    let total_doc = 0
    documentos.forEach(element => {
      total_doc += parseFloat(element.doc_importe)
    });
    this.setState({ documentos: documentos, total_doc: total_doc })
  };

  render() {
    const columns = [
      {
        dataField: "billetes",
        text: "Billetes",
        sort: true,
        headerStyle: () => { return { width: "170px" }; },
        hidden: true,
      },
      {
        dataField: "monedas",
        text: "Monedas",
        sort: true,
        headerStyle: () => { return { width: "170px" }; },
        hidden: true,
      },
      {
        dataField: "total_efectivo",
        text: "Total Efectivo",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "documentos",
        text: "Documentos",
        sort: true,
        headerStyle: () => { return { width: "170px" }; },
        hidden: true,
      },
      {
        dataField: "total_doc",
        text: "Total Doc",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_otros",
        text: "Total Otros",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_arqueado",
        text: "Total Arqueado",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "total_fondo",
        text: "Total Fondo",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "diferencia",
        text: "Diferencia",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_captura",
        text: "Fecha Captura",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );
    const lis_docs_id = this.state.frm_lista_documentos.map((el) => {
      const url_doc =
        `http://143.198.191.211/api/securedocs/${el.filename}?api_token=${localStorage.api_token}`;
      return (
        <li key={el.id}>
          <a href={url_doc} target="_blank">
            {el.descripcion}
          </a>
        </li>
      );
    });
    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">ARQUEO DE FONDO REVOLVENTE</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 26a referente
                a arqueo de fondo revolvente, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f26as}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga PDF"
                              target="_blank"
                              href={
                                `http://143.198.191.211/pdf/?a=${this.props.match.params.ambito_id}&f=26a`
                              }
                            >
                              <FontAwesomeIcon icon={faFilePdf} /> Descargar PDF
                            </a>
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga PDF"
                              target="_blank"
                              href={
                                `http://143.198.191.211/xlsx/?a=${this.props.match.params.ambito_id}&f=26a`
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12">
                <h5>Efectivo</h5>
              </Col>
              <Col xs="12">
                <b> - En Billetes</b>
              </Col>
              <Col xs="12">
                {(this.state.billetes).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="4">
                      {i == 0 &&
                        <Form.Label>
                          Cantidad:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="billetes_cantidad"
                        value={ele.billetes_cantidad}
                        onChange={(e) => this.onChangeBilletesCantidad(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="4">
                      {i == 0 &&
                        <Form.Label>
                          Denominación:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control as="select"
                        custom
                        name="billetes_denominacion"
                        value={ele.billetes_denominacion}
                        onChange={(e) => this.onChangeBilletesDenominacion(i, e)}>
                        <option>$20</option>
                        <option>$50</option>
                        <option>$100</option>
                        <option>$200</option>
                        <option>$500</option>
                        <option>$1,000</option>
                      </Form.Control>
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Importe:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        disabled
                        type="number"
                        step="0.01"
                        name="billetes_importe"
                        value={ele.billetes_importe}
                        onChange={this.onChangeBilletesImporte}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Billete." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellBillete(i, e)}
                        data-tip={`Eliminar Billete de ${ele.billetes_denominacion}`}
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}

                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addBillete}
                      data-tip="Agregar Billete"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Billete
                    </button>
                  </Col>
                </Row>
              </Col>
            </Form.Row>
            <br></br>
            <Form.Row>
              <Col xs="12">
                <b> - En Moneda</b>
              </Col>
              <Col xs="12">
                {(this.state.monedas).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="4">
                      {i == 0 &&
                        <Form.Label>
                          Cantidad:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        name="monedas_cantidad"
                        value={ele.monedas_cantidad}
                        onChange={(e) => this.onChangeMonedasCantidad(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="4">
                      {i == 0 &&
                        <Form.Label>
                          Denominacion:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control as="select"
                        custom
                        name="monedas_demoninacion"
                        value={ele.monedas_demoninacion}
                        onChange={(e) => this.onChangeMonedasDemoninacion(i, e)}>
                        <option>$0.05</option>
                        <option>$0.10</option>
                        <option>$0.20</option>
                        <option>$0.50</option>
                        <option>$1</option>
                        <option>$2</option>
                        <option>$5</option>
                        <option>$10</option>
                        <option>$20</option>
                        <option>$50</option>
                        <option>$100</option>
                      </Form.Control>
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Importe:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="monedas_importe"
                        disabled
                        value={ele.monedas_importe}
                        onChange={(e) => this.onChangeMonedasImporte(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Moneda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellMoneda(i, e)}
                        data-tip={`Eliminar Moneda de ${ele.monedas_denominacion}`}
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addMoneda}
                      data-tip="Agregar Moneda"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Moneda
                    </button>
                  </Col>
                </Row>
              </Col>
            </Form.Row>
            <br></br>
            <Form.Row>
              <Col xs="12">
                <Row>
                  <Col xs="12" md="8">

                  </Col>
                  <Col xs="12" md="4">
                    <Form.Label>
                      <b>Total Efectivo:</b>
                      <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                        <Button
                          variant="light"
                          onClick={(e) => {
                            this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                          }}
                        >
                          <FontAwesomeIcon icon={faQuestionCircle} />
                        </Button>
                      </OverlayTrigger>
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      step="0.01"
                      name="total_efectivo"
                      value={this.state.total_efectivo}
                    />
                  </Col>
                </Row>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col xs="12">
                <h5>Documentación Comprobatoria</h5>
              </Col>
            </Form.Row>
            <br></br>
            <Form.Row>
              <Col xs="12">
                {(this.state.documentos).map((ele, i) =>
                  <Row key={i}>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Fecha:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Anotar la fecha de corte de la información." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="date"
                        name="fecha"
                        value={ele.fecha}
                        onChange={(e) => this.onChangeFecha(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          Beneficiario:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Anotar la fecha de corte de la información." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="beneficiario"
                        value={ele.beneficiario}
                        onChange={(e) => this.onChangeBeneficiario(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="3">
                      {i == 0 &&
                        <Form.Label>
                          No Folio:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Anotar la fecha de corte de la información." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="text"
                        name="no_folio"
                        value={ele.no_folio}
                        onChange={(e) => this.onChangeNoFolio(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="2">
                      {i == 0 &&
                        <Form.Label>
                          Importe:
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="doc_importe"
                        value={ele.doc_importe}
                        onChange={(e) => this.onChangeDocImporte(i, e)}
                      />
                    </Col>
                    <Col xs="12" md="1">
                      {i == 0 &&
                        <Form.Label>
                          <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                            <Button
                              tabindex="-1"
                              variant="light"
                              onClick={(e) => {
                                this.setState({ input_tooltip: "Eliminar Documento." });
                              }}
                            >
                              <FontAwesomeIcon icon={faQuestionCircle} />
                            </Button>
                          </OverlayTrigger>
                        </Form.Label>
                      }
                      {i == 0 && <br></br>}
                      <button
                        className="btn btn-danger"
                        onClick={(e) => this.dellDocumento(i, e)}
                        data-tip="Eliminar Documento"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    </Col>
                  </Row>
                )}
                <br></br>
                <Row className="justify-content-md-center">
                  <Col md="auto">
                    <button
                      className="btn btn-primary btn-add-anidado"
                      onClick={this.addDocumento}
                      data-tip="Agregar Documento"
                    >
                      <FontAwesomeIcon icon={faPlus} /> Agregar Documento
                    </button>
                  </Col>
                </Row>
              </Col>
            </Form.Row>
            <br></br>
            <Form.Row>
              <Col xs="12" md="8"></Col>
              <Col xs="12" md="4">
                <Form.Label>
                  <b>Total Documentación Comprobatoria:</b>
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  step="0.01"
                  name="total_doc"
                  value={this.state.total_doc}
                  onChange={this.onChangeTotalDocProb}
                />
              </Col>
            </Form.Row>
            <Form.Row>
              <Col xs="12">
                <h5>Otros Documentos (Cheques, Vales De Caja, Etc.)</h5>
              </Col>
            </Form.Row>
            <br></br>
            <Form.Row>
              <Col xs="12" md="8"></Col>
              <Col xs="12" md="4">
                <Form.Label>
                  <b>Total Otros:</b>
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="total_otros"
                  value={this.state.total_otros}
                  onChange={this.onChangeTotalOtros}
                />
              </Col>
              <Col xs="12" md="8"></Col>
              <Col xs="12" md="4">
                <Form.Label>
                  <b>Total Arqueado:</b>
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  step="0.01"
                  name="total_arqueado"
                  value={this.state.total_arqueado}
                  onChange={this.onChangeTotalArqueado}
                />
              </Col>
              <Col xs="12" md="8"></Col>
              <Col xs="12" md="4">
                <Form.Label>
                  <b>Total Fondo:</b>
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="total_fondo"
                  value={this.state.total_fondo}
                  onChange={this.onChangeTotalFondo}
                />
              </Col>
              <Col xs="12" md="8"></Col>
              <Col xs="12" md="4">
                <Form.Label>
                  <b>Diferencia:</b>
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  step="0.01"
                  name="diferencia"
                  value={this.state.diferencia}
                  onChange={this.onChangeDiferencia}
                />
              </Col>
              <Col xs="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} disabled={this.state.loading || this.state.noEdit} className="btn-ejecutar">
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.loading || this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Efectivo:
                    </Col>
                    <Col xs={10}>{this.state.total_efectivo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Doc:
                    </Col>
                    <Col xs={10}>{this.state.total_doc}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Otros:
                    </Col>
                    <Col xs={10}>{this.state.total_otros}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Arqueado:
                    </Col>
                    <Col xs={10}>{this.state.total_arqueado}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Total Fondo:
                    </Col>
                    <Col xs={10}>{this.state.total_fondo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Diferencia:
                    </Col>
                    <Col xs={10}>{this.state.diferencia}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha Captura:
                    </Col>
                    <Col xs={10}>{this.state.fecha_captura}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout>
    );
  }
}

export default F26as;
